/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/document';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RetrieveNewYorkFinanceDisclosureDocumentRequest": {
                "fields": {}
              },
              "RetrieveNewYorkFinanceDisclosureDocumentResponse": {
                "fields": {
                  "document": {
                    "type": ".squareup.corporate_card.resources.Document",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveNewYorkFinanceDisclosureDocumentRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveNewYorkFinanceDisclosureDocumentResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveNewYorkFinanceDisclosureDocumentRequest @ squareup/corporate_card/service/retrieve_new_york_finance_disclosure_document.proto at 9:1
 */
export const RetrieveNewYorkFinanceDisclosureDocumentRequest = $root.lookupType('squareup.corporate_card.service.RetrieveNewYorkFinanceDisclosureDocumentRequest');
fixType(RetrieveNewYorkFinanceDisclosureDocumentRequest);
Builder.createAndAttachToType(RetrieveNewYorkFinanceDisclosureDocumentRequest);
/**
 * SOURCE RetrieveNewYorkFinanceDisclosureDocumentResponse @ squareup/corporate_card/service/retrieve_new_york_finance_disclosure_document.proto at 15:1
 */
export const RetrieveNewYorkFinanceDisclosureDocumentResponse = $root.lookupType('squareup.corporate_card.service.RetrieveNewYorkFinanceDisclosureDocumentResponse');
fixType(RetrieveNewYorkFinanceDisclosureDocumentResponse);
Builder.createAndAttachToType(RetrieveNewYorkFinanceDisclosureDocumentResponse);